import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

export function fundFlowList(data) { return axios.post(`${base.url}/payment/fundFlow/list`, qs.stringify(data)) }
export function fundFlowExport(data) { return axios.post(`${base.url}/payment/fundFlow/export`, qs.stringify(data), { responseType: 'blob' }) }
